import { useEffect, useState } from 'react';

/** 미디어 쿼리가 맞는지 — 화면 폭이 바뀌면 따라 바뀐다 */
const useMedia = (query) => {
  const get = () => typeof window !== 'undefined' && !!window.matchMedia?.(query).matches;
  const [match, setMatch] = useState(get);
  useEffect(() => {
    const mq = window.matchMedia?.(query);
    if (!mq) return undefined;
    const on = () => setMatch(mq.matches);
    on();
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);
  return match;
};

/** 모바일 (<768) — 보드는 한 번에 열 하나, 스윔레인은 아코디언, 타임라인은 날짜별 리스트 */
export const MOBILE = '(max-width: 767px)';

export default useMedia;
